<template>
  <modal :show="show" @close="$emit('close')" class="cip-modal" modal-classes="cip-modal__dialog">
    <template slot="header">
      <h5 class="modal-title mb-0">Course Cannot Be Deleted</h5>
    </template>

    <p class="cip-lead">
      <strong v-if="courseName">{{ courseName }}</strong><span v-else>This course</span>
      is part of {{ pathways.length === 1 ? 'a pathway' : 'one or more pathways' }} and cannot be deleted.
      Edit the pathway to remove or modify this course before deleting it.
    </p>

    <p class="cip-label">{{ pathways.length === 1 ? 'Pathway' : 'Pathways' }}</p>
    <ul class="cip-list">
      <li v-for="p in pathways" :key="p.id" class="cip-item">
        <span class="cip-item__title">
          {{ p.title }}
          <span class="cip-status" :class="'cip-status--' + p.status">{{ statusLabel(p.status) }}</span>
        </span>
        <base-button type="primary" size="sm" @click.prevent="edit(p)">Edit Pathway</base-button>
      </li>
    </ul>

    <template slot="footer">
      <button type="button" class="btn greybtn cip-close" @click.prevent="$emit('close')">Close</button>
    </template>
  </modal>
</template>

<script>
/**
 * Shown instead of the delete confirmation when a course is a module of one
 * or more pathways (Safe Dig). Each pathway gets its own Edit Pathway button
 * into the builder, where the module can be removed; the course can be
 * deleted once no pathway references it.
 */
export default {
  name: 'CourseInPathwayModal',
  props: {
    show: { type: Boolean, default: false },
    courseName: { type: String, default: '' },
    /** [{ id, title, status }] as returned by course/pathway-usage/{id}. */
    pathways: { type: Array, default: () => [] },
  },
  methods: {
    statusLabel(s) { return { draft: 'Draft', published: 'Published', archived: 'Archived' }[s] || s; },
    async edit(p) {
      // Close first and let the modal's `show` watcher run (it removes
      // body.modal-open) before the route change destroys this page —
      // otherwise the class stays and the builder can't scroll.
      this.$emit('close');
      await this.$nextTick();
      document.body.classList.remove('modal-open');
      this.$router.push('/safedig/pathways/' + p.id + '/edit');
    },
  },
};
</script>

<style scoped>
.cip-modal >>> .cip-modal__dialog { max-width: 460px; }
.cip-close { border-radius: 999px; padding: 0.55rem 1.6rem; font-weight: 600; }
.cip-lead { color: #334155; margin-bottom: 1rem; }
.cip-label { font-size: 0.78rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: #64748b; margin-bottom: 0.4rem; }
.cip-list { list-style: none; margin: 0; padding: 0; border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden; }
.cip-item { display: flex; align-items: center; justify-content: space-between; gap: 1rem; padding: 0.7rem 0.9rem; border-bottom: 1px solid #f1f5f9; }
.cip-item:last-child { border-bottom: 0; }
.cip-item__title { font-weight: 600; color: #1e3a5f; display: inline-flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; }
.cip-status { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; padding: 0.1rem 0.5rem; border-radius: 999px; background: #f1f5f9; color: #475569; }
.cip-status--published { background: #dcfce7; color: #15803d; }
.cip-status--draft { background: #fef9c3; color: #854d0e; }
.cip-status--archived { background: #e2e8f0; color: #475569; }
</style>
